import {
    // FILE_UPLOAD,
    CREATE_ADMIN_SCHEDULED_VISITS,
    RETRIEVE_ADMIN_SCHEDULED_VISITS,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_SCHEDULED_VISITS,
    UPDATE_ADMIN_SCHEDULED_VISITS,
    DELETE_ADMIN_SCHEDULED_VISITS,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminScheduledVisits from "../service/AdminScheduledVisits";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminScheduledVisits.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminScheduledVisits.create(data);
        dispatch({
            type: CREATE_ADMIN_SCHEDULED_VISITS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminScheduledVisits.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_SCHEDULED_VISITS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminScheduledVisits.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_SCHEDULED_VISITS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminScheduledVisits.update(data);
        dispatch({
            type: UPDATE_ADMIN_SCHEDULED_VISITS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminScheduledVisits.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_SCHEDULED_VISITS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminScheduledVisits.trash(data);
        dispatch({
            type: DELETE_ADMIN_SCHEDULED_VISITS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};